import { platformService } from '@aceroll/platform-hacksaw';
import dataActionType from './constants/data-action-type';
import dataEventType from './constants/data-event-type';

// State Events
import dataEventFsRespin from './parsers/data-events/data-event-fs-respin';

// State Actions
import dataActionExpand from './parsers/data-actions/data-action-expand';
import parseMultipliersData from './parsers/parse-multipliers-data';


// Add Event parsers
platformService.stateEventParser.setParser(dataEventType.FS_RESPIN, dataEventFsRespin);

// Add Action parsers
platformService.stateActionParser.setParser(dataActionType.ADD, parseMultipliersData);
platformService.stateActionParser.setParser(dataActionType.MULTIPLY, parseMultipliersData);
platformService.stateActionParser.setParser(dataActionType.EPIC_ADD, parseMultipliersData);
platformService.stateActionParser.setParser(dataActionType.EPIC_MULTIPLIY, parseMultipliersData);
platformService.stateActionParser.setParser(dataActionType.EXPAND, dataActionExpand);

export const platform = platformService;


